import React, {useEffect, useRef, useState, useMemo} from 'react';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';
import { toast } from 'react-toastify';

import filesrc from './../../assets/images/svg/039-file.svg';
import {uploadDocument} from '../../actions/user-api';
import {uploadDocument as uploadDocumentFacilita} from '../../actions/facilita-api';
import Dropzone from 'react-dropzone';
import {FileTypes, FiletypeToDisplayName} from '../../constants/utils/fileTypes';
import {ToasterConfigurations} from '../../constants/toasterText/configurations';
import $ from 'jquery';

export const ModalAddFile = ({ userId, currentPath, onFileAdded, isDefaultFiles, isFacilita, injectedFiles }) => {
	const dispatch = useDispatch();
	const formRef = useRef();
	const [files, setFiles] = useState(R.isNil(injectedFiles) ? [] : injectedFiles);
	const [isLoading, setIsLoading] = useState(false);

	if(R.isNil(isFacilita)){
        isFacilita = false;
    }
	if(R.isNil(isDefaultFiles)){
		isDefaultFiles = false;
	}
	useEffect(()=> {
		setFiles(injectedFiles);
	}, [injectedFiles]);

	const selectableFileTypesFacilita = useMemo(() => Object.keys(FileTypes)
			.filter(fileType => 
				fileType !== FileTypes.Letter && 
				fileType !== FileTypes.Signature &&
				fileType !== FileTypes.Other &&
				fileType !== FileTypes.ProfilePicture &&
				fileType !== FileTypes.Folder &&
				fileType !== FileTypes.FolderRH &&
				fileType !== FileTypes.Payslip)
			.map(key => {
				return {
					key: key,
					fileType: FileTypes[key],
					displayName: FiletypeToDisplayName(FileTypes[key])
				};		
			}).sort((a,b) => a.displayName.localeCompare(b.displayName))
		, [FileTypes]);
	
	const selectableFileTypesAnticipa = [{
			key: FileTypes.UserIdCard,
			fileType: FileTypes.UserIdCard,
			displayName: FiletypeToDisplayName(FileTypes.UserIdCard, isFacilita)
		},
		{
			key: FileTypes.UserFamilyRecordBook,
			fileType: FileTypes.UserFamilyRecordBook,
			displayName: FiletypeToDisplayName(FileTypes.UserFamilyRecordBook, isFacilita)
		},
		{
			key: FileTypes.UserDonation,
			fileType: FileTypes.UserDonation,
			displayName: FiletypeToDisplayName(FileTypes.UserDonation, isFacilita)
		},
		{
			key: FileTypes.Other,
			fileType: FileTypes.Other,
			displayName: FiletypeToDisplayName(FileTypes.Other, isFacilita)
		}
		].sort((a,b) => a.displayName.localeCompare(b.displayName));

	return (
		<div className="modal fade px-0" id="fichier" aria-labelledby="fichierLabel" aria-hidden="true">
			<div className="modal-dialog px-2 container-base">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-secondary text-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Upload docs</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="fichierLabel">Charger des fichiers</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default pt-0">
						<form className="block" id="accordionUpload" noValidate ref={formRef}>
							{
								R.isEmpty(files) ?
									<div className={"card rounded upload-card border-0 bg-mix bg-white--hover shadow-xs--hover"}>
										<Dropzone onDrop={acceptedFiles => {
											if(!R.isEmpty(acceptedFiles)){
												setFiles(acceptedFiles.map(f => {
													f.description = null;
													f.fileType = isDefaultFiles ? "default" : FileTypes.Other
													return f;
												}));
											}
										}} 
										onDropRejected={(filesErrors) => {
											filesErrors.map(fileErrors => fileErrors.errors.map(error => {
												if(error.code === 'file-invalid-type'){
													toast.error(`Le fichier '${fileErrors.file.name}' n'est pas un fichier PDF.`, ToasterConfigurations)
												}
											}))
										}}
										accept={"application/pdf"}>
											{({ getRootProps, getInputProps }) => (
												<div {...getRootProps()}>
													<input {...getInputProps()} />
													<div className="card-body flex-row gap-3 my-auto" role="button">
														<div className={"rounded-max d-inherit h-6 w-6 rounded-max text-center my-auto flex-shrink-0 bg-dim"}>
															<i className="eva eva-cloud-upload-outline h1 lh-1 m-auto o-60"></i>
														</div>
														<div className="flex-column flex-fill my-auto">
															<h3 className="fs-root mb-0 lh-copy my-auto">Parcourir...</h3>
															<p className={"small o-60 mb-0 lh-copy my-auto container-up"}>Cliquez ici pour choisir les fichiers ou glissez et déposez les ici.</p>
														</div>
													</div>
												</div>
											)}
										</Dropzone>
									</div>
								:
									<div className={"card rounded upload-card border-0"}>
										<div className="card-body flex-column p-3 gap-2 my-auto">
										{
											files.map((file, index) => (
												<React.Fragment key={index}>
													{/* <h3 className="fs-1 o-60 mb-1 text-uppercase font-weight-bold ls-2">{file.fileType}</h3> */}
													<div className="flex-row flex-grow-1 gap-3 my-auto" role="button">
														<div className={"rounded-max d-inherit h-6 w-6 rounded-max text-center flex-shrink-0 m-auto bg-light"}>
															{/* <i className="eva eva-cloud-upload-outline h1 lh-1 m-auto o-60"></i> */}
															<img className="img-fluid h-4 m-auto" src={filesrc} alt="file" />
														</div>
														<div className="flex-column flex-fill my-auto">
															<h3 className="fs-root mb-0 lh-copy mt-auto" key={file.name}>{file.name}</h3>
															<div className="block flex-row mt-1 mb-auto">
																{/* <i role="button" className="eva eva-trash-2-outline trash-btn mr-1" onClick={() => { setFiles([]); }}></i> */}
																<input type="text" className={"fs-2 form-control border-0 form-control-sm my-auto px-2 bg-light"} placeholder="description" onChange={(e) => {
																	setFiles(files.map(f => {
																		if(f === file){
																			f.description = e.target.value;
																		}
																		return f;
																	}))
																}} />
																
															</div>
															{
																isDefaultFiles ? 
																	<div className="block flex-row mt-1 mb-auto">
																		<div className="form-group">
																			<select className="fs-2 form-control-sm border-0 custom-select w-100 bg-light" id={"fileType_modalAddFile_" + index} aria-label="Default libelles" onChange={(e) => {
																				setFiles(files.map(f => {
																					if(f === file){
																						f.fileType = e.target.value;
																					}
																					return f;
																				}));
																				document.getElementById("fileType_modalAddFile_" + index).setCustomValidity("");
																			}}>
																				<option value="default" defaultValue>Choisir un type...</option>
																				{
																					isFacilita ?
																						selectableFileTypesFacilita.map(selectableFileType =>{
																							return <option value={selectableFileType.fileType} key={selectableFileType.fileType}>{selectableFileType.displayName}</option>
																						})
																					:
																						selectableFileTypesAnticipa.map(selectableFileType =>{
																							return <option value={selectableFileType.fileType} key={selectableFileType.fileType}>{selectableFileType.displayName}</option>
																						})
																				}
																			</select>
																		</div>
																	</div>
																:
																	""
															}
															
														</div>
													</div>
												</React.Fragment>
											))
										}
										</div>
									</div>

							}
							<div className="flex-row justify-content-end gap-1 pt-0 mt-3">
								<button type="button" className="btn btn-light me-auto" data-dismiss="modal" onClick={(e) =>{
									setFiles([]);
								}}>Annuler</button>
								<button type="submit" className={"btn btn-secondary loading-btn ml-2" + (isLoading ? " show" : "")} disabled={R.isEmpty(files)} onClick={(e) => {
									e.preventDefault();
									formRef.current.classList.add('was-validated');
									if(isDefaultFiles){
										files.forEach((file, index) => {
											if(file.fileType === "default"){
												document.getElementById("fileType_modalAddFile_" + index).setCustomValidity("Catégorie invalide");
											}
										})
									}
									
									if (formRef.current.checkValidity()){
										setIsLoading(true);
										let promises = undefined;
										if(isFacilita){
											promises = files.map(file => dispatch(uploadDocumentFacilita(userId, file.fileType, file, file.description, isDefaultFiles ? null : currentPath)));
										}else{
											promises = files.map(file => dispatch(uploadDocument(userId, file.fileType, file, file.description, isDefaultFiles ? null : currentPath)));
										}
										Promise.all(promises)
										.then(() => {
											onFileAdded();
											setIsLoading(false);
											$('.modal').modal("hide");
											setFiles([]);
										});
									}
								}}><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Charger</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}